module.exports = __webpack_public_path__ + "static/media/refresh.1d9257f5.svg";